import React, { createContext, useState, useContext, useEffect } from 'react';

// JSON dosyalarını import et
import trTranslations from '../utils/locales/tr.json';
import enTranslations from '../utils/locales/en.json';

const translations = {
    tr: trTranslations,
    en: enTranslations
};

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    // NOT: `t` her zaman Türkçe ile başlıyordu (translations.tr) ama `language` 'en' ile
    // başlıyordu - iki state senkron değildi, `language`'a bakan her kod (dinamik plan/özellik
    // etiketleri gibi) ilk render'da yanlış dile düşüyordu. İkisi de aynı varsayılanla başlar.
    const [language, setLanguage] = useState('tr');
    const [t, setT] = useState(() => translations.tr);

    useEffect(() => {
        const savedLang = localStorage.getItem('admin_language');
        if (savedLang && translations[savedLang]) {
            setLanguage(savedLang);
            setT(translations[savedLang]);
        }
    }, []);

    const changeLanguage = (lang) => {
        if (translations[lang]) {
            setLanguage(lang);
            setT(translations[lang]);
            localStorage.setItem('admin_language', lang);
        }
    };

    const translate = (key) => {
        return t[key] || key;
    };

    const value = {
        language,
        changeLanguage,
        t: translate
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};